import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Projects", -1)
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProjectEntry = _resolveComponent("ProjectEntry")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.canCreateProjects)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/createProject",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("input", {
              type: "button",
              value: "New Project",
              onClick: navigate
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, projectId) => {
      return (_openBlock(), _createBlock(_component_ProjectEntry, {
        key: projectId,
        "project-id": (projectId as string),
        name: project.projectName
      }, null, 8, ["project-id", "name"]))
    }), 128))
  ]))
}